import { ConceptWalkthrough, type ConceptUiConfig } from '@knolskape/educate-components';
import type { EducateModule } from '@/hooks/useEducateModule';
import { useProductHost } from '../../host/useProductHost';

export const ConceptWalkthroughHost = ({ module }: { module: EducateModule }) => {
  const props = useProductHost(module);
  if (!props) return null;
  return (
    <ConceptWalkthrough
      config={props.config as ConceptUiConfig}
      content={props.content}
      mode="play"
      host={props.host}
      storylineId={props.storylineId}
    />
  );
};
